export default __webpack_public_path__ + "static/contest-sweep-image-mobile-9b7bc5a034e56e9aadf353193e9e5494.png";